import { render } from "./Pagination.vue?vue&type=template&id=77f2f437"
import script from "./Pagination.vue?vue&type=script&lang=ts"
export * from "./Pagination.vue?vue&type=script&lang=ts"
script.render = render

export default script